
import { min } from "d3";
import { Component, Vue } from "vue-property-decorator";
import { IJob, Job } from "./Job";
import { Period } from "./Period";
import { PlanSvc } from "./PlanSvc";
import { IResource } from "./Resource"
import { ResourceDefs } from "./ResourceDefs";


@Component({ })
export default class JobPlanner extends Vue {
    
    planSvc: PlanSvc|undefined ;

    key=0;
    keys:any={}

    currentJobId: string = ""
    currentJob: IJob | undefined = undefined;
    currentJobKey: number=0

    targetJobId: string  = "";
    targetResourceId: string  = "";
    sourceJobId: string = "";
    sourceResourceId: string = "";

    targetJob: IJob | undefined = undefined;
    targetResource: IResource | undefined = undefined;
    sourceJob: IJob | undefined = undefined;
    sourceResource: IResource | undefined = undefined;
    planHorizonDays = 5

    async mounted() {
        this.planSvc = new PlanSvc(this.planHorizonDays);
       

        for (let rd of ResourceDefs.resourceDefs) {
          if (
          
              (rd.name.indexOf('RCS')   >-1)
          )
            {

            console.log(rd.name)
            const resource = await this.planSvc.refresh(rd);
            if (resource && resource.time_grid) {
              // Use $nextTick to update the view after each refresh call
              await this.$nextTick();
              this.keys[resource._id] ++; // increase to refresh
            }
          }
        }
        this.key++;
  }

    refresh(resource:IResource|undefined) {

      if (!resource) return;
   
      this.keys[resource._id]++  // increase to refresh
      for (let job of resource.jobs) {
          this.keys[job._id]++
      }
    }

    setSource(resource: IResource, job:IJob) {
      if (resource && job) {
        this.sourceJob = job
        this.sourceResource = resource
        this.sourceJobId = job._id;
        this.sourceResourceId = resource._id;
      }
    }

    setCurrent(resource: IResource|undefined, job:IJob|undefined) {
      if (resource && job) {
        this.currentJob = job
        this.currentJobId = job._id;
        this.currentJobKey++
        this.keys[job._id]++
      }
    }

    setTarget(resource: IResource, job:IJob) {
      if (resource && job) {
        this.targetJob = job
        this.targetResource = resource
        this.targetJobId = job._id;
        this.targetResourceId = resource._id;
      }
    }

    handleDragStart(resource: IResource, job: IJob) {
        this.setSource(resource,job)
    }

    handleDragOver(resource:IResource,job: IJob, event: DragEvent) {
        event.preventDefault();
        event.dataTransfer!.dropEffect = "move";
        this.setTarget(resource,job)
    }

    handleDragLeave() { }

    handleDrop(resource: IResource, job:IJob|undefined) {
      if (! this.planSvc) return 0;

      if (this.sourceResource) {
      console.log('From Resource'+this.sourceResource._id)
      this.sourceResource.log_jobs(this.sourceJob)
      }

      this.planSvc.move_job_here(this.sourceResource, this.sourceJob, resource, job)
      //this.refresh(this.sourceResource)
      //this.refresh(this.targetResource)

  
      if (this.targetResource) {
      console.log('To Resource'+this.targetResource._id)
      resource.log_jobs(this.sourceJob)
      }
      this.setCurrent(this.sourceResource,this.sourceJob)
      this.key++
   }

    duration_to_pixels(minutes: number):number {
        return (minutes / 60 / 24) * 1000
    }

    time_to_pixels(date: Date):number {
        if (! this.planSvc) return 0;
        const diffInMilliseconds = Math.abs(date.getTime() - this.planSvc.plannigPeriod.startTime.getTime());
        const minutes = Math.floor(diffInMilliseconds / (1000 * 60)); // 1000 milliseconds in a second, 60 seconds in a minute
        return this.duration_to_pixels(minutes)
    }

    format_date(d:Date) {
      return Period.format_date(d)
    }

    format_hour(d:Date) {
      return Period.format_hour(d)
    }

    convert(zlecprod_idm:string) {
      let arr = zlecprod_idm.trim().split('/')
      let tech   = arr[0].trim()
      let nr_zlec= arr[1].trim()
      let year   = arr[2].trim()

      while(tech.length<4) tech=tech+'_'

      const filename=tech+"_"+nr_zlec+"_"+year+"_____.pdf"  // 4____16781_2023_____.pdf
      return filename;
  }
  }

